import { Text } from "@mantine/core";
import CustomBadge from "components/ui/CustomBadge/CustomBadge";
import CustomTable from "components/ui/CustomTable/CustomTable";
import {
  RECEIPT_STATUS_COLOR,
  RECEIPT_STATUS_LABEL,
} from "constants/common/receipt";
import { Payment, PaymentStatus } from "constants/types/report";
import { MRT_ColumnDef } from "mantine-react-table";
import { FC, useMemo } from "react";
import {
  formatBankAccount,
  formatCurrency,
  formatDate,
} from "utils/helpers/format";

const PaymentSubTable: FC<{ payments: Payment[] }> = ({ payments }) => {
  const columns = useMemo<MRT_ColumnDef<Payment>[]>(
    () => [
      { accessorKey: "code", header: "Mã phiếu", size: 150 },
      {
        accessorKey: "paymentDate",
        header: "Ngày thanh toán",
        size: 150,
        Cell: ({ cell }) => formatDate(cell.getValue<number>()),
      },
      {
        accessorKey: "amount",
        header: "Số tiền",
        size: 150,
        Cell: ({ cell }) => formatCurrency(cell.getValue<number>()),
      },
      {
        accessorKey: "bankAccountName",
        header: "Tài khoản ngân hàng",
        size: 200,
        Cell: ({ cell }) => formatBankAccount(cell.getValue<string>()),
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 160,
        grow: false,
        Cell: ({ cell }) => {
          const status = cell.getValue<PaymentStatus>();
          return (
            <CustomBadge
              label={RECEIPT_STATUS_LABEL[status] ?? status}
              color={RECEIPT_STATUS_COLOR[status] ?? "gray"}
            />
          );
        },
      },
    ],
    [],
  );

  if (!payments.length) {
    return (
      <Text size="sm" c="dimmed" ta="center" py="sm">
        Chưa có giao dịch thu tiền
      </Text>
    );
  }

  return <CustomTable columns={columns} data={payments} />;
};

export default PaymentSubTable;
